import { useEffect, useState } from "react";
import {
	PayPalButtons
} from "@paypal/react-paypal-js";
import { apiRequest, API_CONSTANTS } from "../libs/apiRequest";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

function GTCSubscriptionButton (props: any) {
    const [subscriptionId, setSubscriptionId] = useState<string>('');
    const navigate = useNavigate();
    const { service, id, plan } = useParams();

    const subscriptionIntent = async (subId: string) => {
        try {
            const res = await apiRequest({
                method: "GET",
                api: API_CONSTANTS.PRIVATE_API,
                fn: "subscriptionintent",
                data: {
                    subscriptionId: subId,
                    chanId: id,
                    plan: plan,
                    service: service
                } 
            });
            // console.log("subscriptionIntent", res)
            if (res && res.status == 200) {
                setSubscriptionId(subId);
            } else {
                navigate(-1);
            }
        } catch (error) {
            console.log("subscriptionIntent", error)
            navigate(-1)
        }
    }


	return (
        <PayPalButtons
            createSubscription={async (data, actions) => {
                console.log("createSubscription", data, actions);
                const subId = await actions.subscription
                    .create({
                        plan_id: props.planId,
                    })
                    .then((orderId) => {
                        // Your code here after create the order
                        return orderId;
                    });
                // oi = "I-UD2FFDB9DK1E" - Subscription Id
                // console.log("createSubscription", subId)
                setSubscriptionId(subId);
                await subscriptionIntent(subId)
                return subId;
            }}
            onApprove={async (data: any) => {
                // console.log("onApprove success", data)
                // data.orderID = "6H361891PV890090W"
                // data.subscriptionID = "I-UD2FFDB9DK1E"
                if (data && data.orderID && data.subscriptionID) {
                    props.success({
                        orderId: data?.orderID,
                        subscriptionId: data.subscriptionID
                    });
                }
            }}
            style={{
                label: "subscribe",
                shape: "pill",
                layout: "vertical"
            }}
        />
    );
}

export default GTCSubscriptionButton;